import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {take} from 'rxjs/operators';
import {CoreConfig} from '../../../../../@core/types';
import {AuthenticationService} from '../../../../auth/service';
import {passwordsMustMatch, UserRegistrationValidators} from '../form-validatation';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone:false
})
export class ResetPasswordComponent implements OnInit, OnDestroy{

    // Public
    public coreConfig: CoreConfig;
    public loading = false;
    public submitted = false;
    public error = '';
    public changePasswordSucceeded = false;
    public readonly  redirectTimeout = 10;

    public changePasswordForm = this._formBuilder.group({
        password: ['', UserRegistrationValidators.password],
        confirmPassword: ['', Validators.required],
    },{
        validators:[passwordsMustMatch('password', 'confirmPassword')]
    });
    // Private
    private _onDestroy: Subject<void> = new Subject<void>();
    private _token:string ='';
    private redirectTimeoutInstance= null;

    constructor(
        private activatedRoute: ActivatedRoute,
        private _formBuilder: FormBuilder,
        private _authService:AuthenticationService,
        private _router: Router
    ) {

    }

    ngOnInit() {
        this.activatedRoute.data.subscribe(({token}) => {
            this._token = token;
        });
    }

    ngOnDestroy(): void {
        this._onDestroy.next();
        this._onDestroy.complete();

        if(this.redirectTimeoutInstance){
            clearTimeout(this.redirectTimeoutInstance);
        }
    }

    onSubmit() {
        this.submitted = true;
        this.error= '';
        if (this.changePasswordForm.valid) {
            this.loading = true;
            this._authService.resetPassword(
                this.changePasswordForm.value.password,
                this.changePasswordForm.value.confirmPassword,
                this._token)
                .pipe(take(1))
                .subscribe({
                    next:()=>{
                        this.error ='';
                        this.loading = false;
                        this.submitted = false;
                        this.changePasswordSucceeded = true;

                        this.redirectTimeoutInstance = setTimeout(()=>{
                            this._router.navigate(['//login'])
                        },this.redirectTimeout * 1000);
                    },
                    error:(error)=>{
                        this.loading = false;
                        this.submitted = false;
                        this.error = error;
                    }
                })
        }
    }
}
